import { library } from '@fortawesome/fontawesome-svg-core';

import { far } from '@fortawesome/pro-regular-svg-icons';

library.add(far);
